import { getAdditionalInfoVal } from '../getAdditionalInfoVal';
import { CARDS_INFO_KEY } from '../../constants/cards';
export var getCardIdsFromAdditionalInfo = function (additionalInfo, defaultValue) {
    var _a;
    if (defaultValue === void 0) { defaultValue = []; }
    var cardIds = ((_a = JSON.parse(getAdditionalInfoVal(additionalInfo, CARDS_INFO_KEY) || '[]')) === null || _a === void 0 ? void 0 : _a.map(function (c) { return (c === null || c === void 0 ? void 0 : c.cardId) || ''; })) || [];
    return !cardIds || (cardIds === null || cardIds === void 0 ? void 0 : cardIds.length) === 0 ? defaultValue : cardIds;
};
//# sourceMappingURL=getCardIdsFromAdditionalInfo.js.mapimport { getAdditionalInfoVal } from '../getAdditionalInfoVal';
import { CARDS_INFO_KEY } from '../../constants/cards';
export var getCardIdsFromAdditionalInfo = function (additionalInfo, defaultValue) {
    var _a;
    if (defaultValue === void 0) { defaultValue = []; }
    var cardIds = ((_a = JSON.parse(getAdditionalInfoVal(additionalInfo, CARDS_INFO_KEY) || '[]')) === null || _a === void 0 ? void 0 : _a.map(function (c) { return (c === null || c === void 0 ? void 0 : c.cardId) || ''; })) || [];
    return !cardIds || (cardIds === null || cardIds === void 0 ? void 0 : cardIds.length) === 0 ? defaultValue : cardIds;
};
//# sourceMappingURL=getCardIdsFromAdditionalInfo.js.map